import { AccountService } from '@clickd-angular/common-lib';
import * as i0 from "@angular/core";
import * as i1 from "@clickd-angular/common-lib";
var AddCommonQueryStringParamsToMscrmappApisInterceptor = /** @class */ (function () {
    function AddCommonQueryStringParamsToMscrmappApisInterceptor(accountService) {
        this.accountService = accountService;
    }
    AddCommonQueryStringParamsToMscrmappApisInterceptor.prototype.intercept = function (req, next) {
        if (req.url.includes('api/Editors_v2') || req.url.includes('api/FileManager_v2')) {
            var sessionParams = req.params
                .append('accountKey', this.accountService.accountKey)
                .append('userlcid', this.accountService.userlcid);
            var withSessionInfoReq = req.clone({ params: sessionParams });
            return next.handle(withSessionInfoReq);
        }
        return next.handle(req);
    };
    AddCommonQueryStringParamsToMscrmappApisInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AddCommonQueryStringParamsToMscrmappApisInterceptor_Factory() { return new AddCommonQueryStringParamsToMscrmappApisInterceptor(i0.ɵɵinject(i1.AccountService)); }, token: AddCommonQueryStringParamsToMscrmappApisInterceptor, providedIn: "root" });
    return AddCommonQueryStringParamsToMscrmappApisInterceptor;
}());
export { AddCommonQueryStringParamsToMscrmappApisInterceptor };
